import React from "react";
import Modal from "react-modal";
import Typography from "@mui/material/Typography";

const LoadingModal = ({
  isOpen,
  onRequestClose
}) => {
  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        shouldCloseOnOverlayClick={false}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <Typography
          style={{
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          Loading, Please wait...
        </Typography>
      </Modal>
    </>
  );
};

export default LoadingModal;
